import _ from 'lodash'
export default function search(state = [], action) {
  const newState = _.cloneDeep(state)
  switch (action.type) {
    case 'RESET_RESPONSE':
      return Object.assign({}, {}, { loading: false, result: false, data: [] })
    case 'SEARCHING':
      return Object.assign({}, {}, { loading: true, result: false, data: [] })
    case 'SEARCH_FETCHED':
      return Object.assign({}, {}, { loading: false, data: action.data.search, result: true, aut: action.data.autList })
    case 'SEARCH_FAILED':
      return Object.assign({}, newState, 
        { message: 'Errore nella ricerca', 
          errorCode: 'error_search', 
          loading: false, 
          result: false, 
          error: action.data.error, 
          access: action.data.check, 
          query: action.data.query, 
          license: action.data.license, 
          free_trial_expired: action.data.free_trial_expired
        })
    case 'SEARCHING_MORE':
      return Object.assign({}, {}, { loadingMore: true, result: true, data: [] })
    case 'SEARCH_MORE_FETCHED':
      return Object.assign({}, {}, { loadingMore: false, data: action.data.search, result: true })
    case 'SEARCH_MORE_FAILED':
      return Object.assign({}, newState, { message: 'Errore nella ricerca', errorCode: 'error_search', loadingMore: false, result: true, error: action.data.error })
    default:
      return Object.assign({}, {}, { loading: false, result: true, data: newState.data ? newState.data : [] })
  }
}
